import { createFileRoute, redirect } from "@tanstack/react-router";

// 301 redirect: legacy /services/managed-it → canonical /services/managed-it-services
export const Route = createFileRoute("/services_/managed-it")({
  beforeLoad: () => {
    throw redirect({
      to: "/services/managed-it-services",
      statusCode: 301,
    });
  },
});
